<template>
    <div class="newpersonWrap">
        <!-- 头部 -->
        <div class="redpacket_header">
            <i @click="goBack" class="iconfont icon-left"></i>
            <h2>新人大礼包</h2>
            <p @click="getLibao">一键领取</p>
        </div>

        <!-- content -->
        <div class="redpacket_content">
            <ul class="content_one">
                <li class="redpacket_list" v-for="val in getList" :key="val.id" @click="goUrl(val)">
                    <div class="list_left">
                        ￥<span>{{val.money}}</span>
                    </div>
                    <div class="list_right">
                        <div class="right_text">
                            <h3>抵用券</h3>
                            <p>{{val.name}}</p>
                            <p v-if="val.desc!==''">{{val.desc}}</p>
                        </div>
                        <div class="right_use" v-if="val.received===1">
                            <p>{{val.expired_at}}</p>
                            <p class="use_text">去使用<i class="iconfont icon-jiantou"></i></p>
                        </div>
                        <div class="right_use" v-else>
                            <div class="lingqv" @click.stop="getSingle(val)">领取</div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import qs from "qs"
import axios from "axios"
import { getLiBao } from "@/api/Redpacket"
export default {
    name: "Newperson",
    data(){
        return{
            getList:[],
            getId: []
        }
    },
    methods:{
        // 返回
        goBack(){
            location.href = 'http://m.lepu.cn/user/member'
        },
        // 跳转路径
        goUrl(val){
            var url = val.url
            location.href = url
        },
        // 获取默认数据
        getDefault(){
            this.ajax.get('//api.lepu.cn/app/gift/index').then(res=>{
                var res = res.data
                if(res.data.code === 1){
                    this.getList = res.data.data
                    this.getList.map(val=>{
                        if(val.received==0){
                            this.getId.push(val.id)
                        }
                    })
                }else{
                    this.$toast({
                        message: res.note,
                        position: 'middle',
                        duration: 2000
                    })
                }
            })
        },
        // 一键领取
        getLibao(){
            var that = this
            axios.create({
                baseURL: 'url',
                timeout: 10000,
                headers: { 'Content-Type': 'application/json' }
            }).post('//api.lepu.cn/app/gift/receive',qs.stringify({
                    ids: that.getId.join(",")
                }),{
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
                }).then(function(res){
                    var res = res.data
                    if(res.data.code == 0){
                        that.$toast({
                            message: res.note,
                            position: 'middle',
                            duration: 2000
                        })
                    }else if(res.data.code == 1){
                        that.getDefault()
                        that.$toast({
                            message: res.note,
                            position: 'middle',
                            duration: 2000
                        })
                    }
                }).catch(function(error){
                console.log(error);
                })
        },
        // 点击单个领取
        getSingle(val){
            this.getId = []
            if(val.received == 0){
                this.getId.push(val.id)
                this.getLibao()
            }else{
                var url = val.url
                location.href = url
            }
        }
    },
    created(){
        this.getDefault()
    }
}
</script>
<style lang="scss" scoped>
.newpersonWrap{
    width:100%;
    height: 100%;
    background:#f5f5f5;
    display: flex;
    flex-direction: column;
}

// 头部
.redpacket_header{
    width: 100%;
    height: .98rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 .32rem;
    box-sizing: border-box;
    background:#fff;

    i{
        padding-right: .32rem;
        box-sizing: border-box;
    }

    h2{
        font-size: .38rem;
    }

    p{
        font-size: .3rem;
    }
}

.redpacket_content{
    flex: 1;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    padding: 0 .3rem;
    box-sizing: border-box;

    ul{

        .redpacket_list{
            width: 100%;
            height: 1.6rem;
            background: url("//assets.lepucdn.cn/vuetest/images/packetBg.jpg");
            background-size: 100% 1.6rem;
            margin-top: .34rem;
            display: flex;
            align-items: center;

            .list_left{
                width: 1.66rem;
                text-align: center;
                font-size: .24rem;
                color: #ebb00c;
                font-weight: 800;

                span{
                    font-size: .5rem;
                }
            }

            .list_right{
                flex: 1;
                height: 100%;
                display: flex;
                padding-left: .3rem;
                padding-right: .3rem;
                box-sizing: border-box;

                .right_text{
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    text-align: left;
                    height: 100%;

                    h3{
                        font-size: .3rem;
                        margin-bottom: .04rem;
                        font-weight: 900;
                    }

                    p{
                        width: 100%;
                        font-size: .24rem;

                        &:nth-child(3){
                           color: #999;
                        }
                    }
                }

                .right_use{
                    width: 1.4rem;
                    text-align: right;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    position: relative;
                    height: 100%;

                    .lingqv{
                        width: 1.1rem;
                        height: 0.48rem;
                        border-radius: .5rem;
                        background: #ebb00c;
                        color: #fff;
                        text-align: center;
                        line-height: .48rem;
                    }

                    p{
                        &:nth-child(1){
                            -webkit-transform: scale(0.8);
                            position: absolute;
                            right: -.2rem;
                            top:.14rem;
                            width: 2.6rem;
                            color: #999;
                        }
                    }

                    .use_text{
                        font-size: .3rem;
                        color: #ebb00c;
                        height: .4rem;
                        display: flex;
                        align-items: center;

                        i{
                            font-size: .2rem;
                        }
                    }

                    .used_text{
                        font-size: .22rem;
                        color: #999;
                    }
                }
            }
        }
    }
}
</style>
